<template>
  <v-container class="content">
    <div
      v-if="loading"
      class="loader"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <div v-else>
      <v-row>
        <v-col
          cols="12"
          lg="4"
          class="pr-lg-12"
        >
          <router-link
            class="all-services"
            :to="backRoute"
          >
            <v-icon
              color="peacock"
              width="15px"
            >
              mdi-arrow-left
            </v-icon>
            <span class="ml-4">{{ $t(backRoute.label) }}</span>
          </router-link>
          <v-card
            outlined
            class="mt-12 detail-card"
          >
            <VehicleAppsDetailCard
              :vehicle-app="vehicleApp"
              :service-annual-price="serviceAnnualPrice"
              :service-month-price="serviceMonthPrice"
              :month="monthlyCostToSend"
              :year="yearlyCostToSend"
              :total-active-vehicles="activeVehicleCount"
            />
          </v-card>
        </v-col>
        <v-col
          cols="12"
          lg="8"
        >
          <VehicleAppsDetailList
            :service="vehicleApp"
            :in-vehicle-app-catalog="catalog"
            :all-trucks="trucks"
            @monthlyCost="monthlyCostReceived"
            @yearlyCost="yearlyCostReceived"
            @activeVehiclesCount="activeVehicleCountReceived"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import VehicleAppsDetailCard from '@/components/VehicleApps/VehicleAppsDetailCard.vue'
import VehicleAppsDetailList from '@/components/VehicleApps/VehicleAppsDetailList.vue'
import apiCalls from '@/helpers/apiCall'
import api from '@/helpers/api'
import prismicService from '@/helpers/prismicService'
import { mapState } from 'vuex'

import vhlAppService from '@/helpers/vehicleAppService'

export default {
  name: 'VehicleAppsDetail',

  components: {
    VehicleAppsDetailCard,
    VehicleAppsDetailList
  },
  data: () => ({
    vehicleApp: undefined,
    monthlyCostToSend: 0,
    yearlyCostToSend: 0,
    serviceAnnualPrice: 0,
    serviceMonthPrice: 0,
    activeVehicleCount: 0,
    loading: false,
    catalog: undefined
  }),
  computed: {
    ...mapState('account', ['currency']),
    ...mapState('trucks', ['trucks']),
    backRoute() {
      let routeName, routeLabel
      if (vhlAppService.isThirdPartyApp(this.vehicleApp)) {
        routeName = 'thirdPartyApps'
        routeLabel = 'vehicleApps_details.txt.all_third_party_apps'
      } else {
        routeName = 'vehicleApps'
        routeLabel = 'vehicleApps_details.txt.all_vehicle_apps'
      }

      return { name: routeName, label: routeLabel }
    }
  },
  watch: {
    currency(newValue) {
      if (newValue && newValue.code) {
        this.setServicePrice(this.vehicleApp, newValue)
      }
    }
  },
  async created() {
    this.loading = true
    await this.getServiceInformation()
    this.loading = false
    await this.getCatalog()
  },
  methods: {
    getServiceInformation() {
      const id = this.$router.history.current.params.id
      const getAppTask = apiCalls.get(api.ProductDetails, id, '')
      const getPrismicTask = prismicService.getProductCatalog()

      return Promise.all([getAppTask, getPrismicTask]).then(
        ([{ data: targetApp }, catalog]) => {
          if (targetApp) {
            this.vehicleApp = this.mapPrismicInfo(targetApp, catalog)
            this.setServicePrice(this.vehicleApp, this.currency)
          }
        }
      )
    },
    getCatalog() {
      this.catalog = this.$router.history.current.params.catalog
    },
    mapPrismicInfo(vehicleApp, catalog) {
      const catalogProduct = catalog.find(
        catalog => catalog.externalKey === vehicleApp.sku
      )
      if (catalogProduct) {
        vehicleApp.name = catalogProduct.title
        vehicleApp.iconUrl = catalogProduct.iconActiveUrl
        vehicleApp.description = catalogProduct.description
      }

      return vehicleApp
    },
    setServicePrice(newService, newCurrency) {
      newService.productRatePlans.forEach(product => {
        product.productRatePlanCharges.forEach(bp => {
          if (bp.billingPeriod === 'Annual') {
            const annualprice = bp.pricing.find(
              pr => pr.currency === newCurrency.code
            )

            this.serviceAnnualPrice = annualprice && annualprice.price
          } else if (bp.billingPeriod === 'Month') {
            const monthPrice = bp.pricing.find(
              pr => pr.currency === newCurrency.code
            )

            this.serviceMonthPrice = monthPrice && monthPrice.price
          }
        })
      })
    },

    monthlyCostReceived(monthlyCost) {
      this.monthlyCostToSend = monthlyCost
    },
    yearlyCostReceived(yearlyCost) {
      this.yearlyCostToSend = yearlyCost
    },
    activeVehicleCountReceived(activeCount) {
      this.activeVehicleCount = activeCount
    }
  }
}
</script>

<style lang="scss">
.content {
  margin-bottom: 260px;

  @media screen and (min-width: 600px) {
    margin-bottom: 200px;
  }
  @media screen and (min-width: 960px) {
    margin-bottom: 140px;
  }
  .loader {
    text-align: center;
    padding-top: 48px;
  }
  .all-services {
    font-size: 0.875rem;
    font-weight: bold;
    color: var(--v-mid-base);
    text-transform: uppercase;
    text-decoration: none;
  }
  .detail-card {
    border-radius: 8px !important;
  }
}
</style>